export enum RouteNames {
  DatasetDetails = 'DatasetDetails',
  InferenceSetup = 'InferenceSetup',
  ModelDatasetDetails = 'ModelDatasetDetails',
  ProjectData = 'ProjectData',
  ProjectDataDatasets = 'ProjectDataDatasets',
  ProjectDataImportDetails = 'ProjectDataImportDetails',
  ProjectDataImports = 'ProjectDataImports',
  ProjectDataTagDetails = 'ProjectDataTagDetails',
  ProjectDataTags = 'ProjectDataTags',
  ProjectDetails = 'ProjectDetails',
  ProjectInferenceCenter = 'ProjectInferenceCenter',
  ProjectInferenceSetup = 'ProjectInferenceSetup',
  ProjectJobs = 'ProjectJobs',
  ProjectJobSetup = 'ProjectJobSetup',
  ProjectLabeling = 'ProjectLabeling',
  ProjectModels = 'ProjectModels',
  ProjectNew = 'ProjectNew',
  ProjectRecordingCenter = 'ProjectRecordingCenter',
  ProjectRecordingSetup = 'ProjectRecordingSetup',
  Projects = 'Projects',
  ProjectTestCenter = 'ProjectTestCenter',
  ProjectTestSetup = 'ProjectTestSetup',
  ProjectTraining = 'ProjectTraining',
}
